import React, { useEffect, useState } from "react";
import { Plans } from "./plans";
import { Link } from "react-router-dom";

const PlanCols = () => (
  <div className="w-[200px] flex flex-col justify-center">
    <div className="w-full h-[140px] text-[#1F2937] font-semibold text-lg leading-6 p-[24px] border border-[#E5E7EB] border-r-0 mt-[160px] rounded-tl-[12px] bg-gradient-to-r from-[#F8FAFC] to-[#F1F5F9]">
      <div className="mt-4">Price</div>
    </div>
    <div className="w-full h-[200px] text-[#1F2937] font-semibold text-lg leading-6 p-[24px] border border-[#E5E7EB] border-r-0 bg-gradient-to-r from-[#F8FAFC] to-[#F1F5F9]">
      <div className="mt-4">Credits</div>
    </div>
    <div className="w-full h-[600px] text-[#1F2937] font-semibold text-lg leading-6 p-[24px] border border-[#E5E7EB] border-r-0 bg-gradient-to-r from-[#F8FAFC] to-[#F1F5F9]">
      <div className="mt-4">Functionality</div>
    </div>
    <div className="w-full h-[450px] text-[#1F2937] font-semibold text-lg leading-6 p-[24px] border border-[#E5E7EB] border-r-0 bg-gradient-to-r from-[#F8FAFC] to-[#F1F5F9]">
      <div className="mt-4">AI Agent Interfaces</div>
    </div>
    <div className="w-full h-[350px] text-[#1F2937] font-semibold text-lg leading-6 p-[24px] border border-[#E5E7EB] border-r-0 rounded-bl-[12px] bg-gradient-to-r from-[#F8FAFC] to-[#F1F5F9]">
      <div className="mt-4">Support</div>
    </div>
  </div>
);

const PlansWeb = ({
  idx,
  title,
  price,
  executions,
  functionality,
  aiAgentInterfaces,
  support,
  activeIdx,
}) => {
  const isHovered = activeIdx === idx;
  
  return (
    <div className="relative">
      <div
        className={`flex flex-col justify-center align-center flex-1 max-w-[380px] min-w-[360px] transition-all duration-200 ${
          isHovered
            ? "border border-[#3B82F6] bg-white shadow-lg"
            : "border border-[#E5E7EB] bg-white shadow-md"
        } ${
          title.pos === "first" && "rounded-tl-[12px]"
        } ${title.pos === "last" && "rounded-tr-[12px]"} rounded-r-[12px]`}
      >
        <div
          className={`h-[160px] flex flex-col justify-center items-center border-b border-[#E5E7EB] ${
            title.pos === "first"
              ? `rounded-tl-[12px] ${!isHovered && "border-l"}`
              : title.pos === "last"
              ? "rounded-tr-[12px]"
              : ""
          } ${
            isHovered 
              ? "bg-gradient-to-r from-[#3B82F6] to-[#1D4ED8]" 
              : "bg-gradient-to-r from-[#F8FAFC] to-[#F1F5F9]"
          } py-[32px] px-[24px] gap-6 rounded-tr-[12px] transition-all duration-200`}
        >
          <div
            className={`${
              isHovered ? "text-white" : "text-[#1F2937]"
            } text-[28px] font-bold text-center transition-colors duration-200`}
          >
            {title.text}
          </div>
          <button
            className={`px-6 py-3 ${
              isHovered 
                ? "bg-white text-[#3B82F6] hover:bg-gray-50" 
                : "bg-[#3B82F6] text-white hover:bg-[#2563EB]"
            } font-semibold rounded-xl transition-all duration-200 shadow-md hover:shadow-lg`}
          >
            <Link to={title.btn.link} target="_blank" className="block">
              <div className="text-sm font-semibold whitespace-nowrap">
                {title.btn.text}
              </div>
            </Link>
          </button>
        </div>
        
        <div className="w-full h-[140px] flex items-center justify-center text-[#1F2937] text-2xl font-bold p-[24px] border-b border-[#E5E7EB] bg-white">
          {price}
        </div>
        
        <div className="w-full h-[200px] flex flex-col justify-start items-start space-y-3 p-[24px] border-b border-[#E5E7EB] bg-white">
          {executions.map((func, index) => (
            <div key={index} className="w-full">{func}</div>
          ))}
        </div>
        
        <div className="w-full h-[600px] flex flex-col justify-start items-start space-y-3 p-[24px] border-b border-[#E5E7EB] bg-white overflow-y-auto">
          {functionality.map((func, index) => (
            <div key={index} className="w-full">{func}</div>
          ))}
        </div>
        
        <div className="w-full h-[450px] flex flex-col justify-start items-start space-y-3 p-[24px] border-b border-[#E5E7EB] bg-white">
          {aiAgentInterfaces.map((func, index) => (
            <div key={index} className="w-full">{func}</div>
          ))}
        </div>
        
        <div
          className={`w-full h-[350px] flex flex-col justify-start items-start space-y-3 p-[24px] bg-white ${
            title.pos === "last" && "rounded-br-[12px]"
          } rounded-br-[12px]`}
        >
          {support.map((sup, index) => (
            <div key={index} className="w-full">{sup}</div>
          ))}
        </div>
      </div>
    </div>
  );
};

const PlansMobile = ({
  idx,
  title,
  price,
  executions,
  functionality,
  aiAgentInterfaces,
  support,
  activeIdx,
}) => {
  const isActive = activeIdx === idx;
  
  return (
    <div className="relative">
      <div
        className={`flex flex-col justify-center align-center border rounded-[16px] w-[350px] bg-white shadow-lg transition-all duration-200 ${
          isActive ? "border-[#3B82F6] shadow-xl" : "border-[#E5E7EB]"
        }`}
      >
        <div
          className={`h-[160px] flex flex-col items-center justify-center rounded-t-[16px] ${
            isActive 
              ? "bg-gradient-to-r from-[#3B82F6] to-[#1D4ED8]" 
              : "bg-gradient-to-r from-[#F8FAFC] to-[#F1F5F9]"
          } p-[24px] gap-4 transition-all duration-200`}
        >
          <div
            className={`${
              isActive ? "text-white" : "text-[#1F2937]"
            } text-[24px] font-bold text-center transition-colors duration-200`}
          >
            {title.text}
          </div>
          <button
            className={`w-full px-4 py-3 ${
              isActive 
                ? "bg-white text-[#3B82F6]" 
                : "bg-[#3B82F6] text-white"
            } font-semibold rounded-xl transition-all duration-200`}
          >
            <div className="text-sm font-semibold">
              {title.btn.text}
            </div>
          </button>
        </div>
        
        <div className="w-full flex flex-col justify-start items-start space-y-4 p-[24px] border-b border-[#E5E7EB]">
          <div className="text-[#3B82F6] text-lg font-semibold">Price</div>
          <div className="w-full text-[#1F2937] text-xl font-bold">{price}</div>
        </div>
        
        <div className="w-full flex flex-col justify-start items-start p-[24px] border-b border-[#E5E7EB]">
          <div className="text-[#3B82F6] text-lg font-semibold mb-[16px]">Credits</div>
          {executions.map((func, index) => (
            <div key={index} className="w-full my-1">{func}</div>
          ))}
        </div>
        
        <div className="w-full flex flex-col justify-start items-start p-[24px] border-b border-[#E5E7EB]">
          <div className="text-[#3B82F6] text-lg font-semibold mb-[16px]">Functionality</div>
          {functionality.map((func, index) => (
            <div key={index} className="w-full my-1">{func}</div>
          ))}
        </div>
        
        <div className="w-full flex flex-col justify-start items-start p-[24px] border-b border-[#E5E7EB]">
          <div className="text-[#3B82F6] text-lg font-semibold mb-[16px]">AI Agent Interfaces</div>
          <div className="w-full flex flex-col justify-start items-start space-y-2">
            {aiAgentInterfaces.map((func, index) => (
              <div key={index} className="w-full">{func}</div>
            ))}
          </div>
        </div>
        
        <div className="w-full flex flex-col justify-start items-start p-[24px] rounded-b-[16px]">
          <div className="text-[#3B82F6] text-lg font-semibold mb-[16px]">Support</div>
          {support.map((sup, index) => (
            <div key={index} className="w-full my-1">{sup}</div>
          ))}
        </div>
      </div>
    </div>
  );
};

const PricingComponent = () => {
  const [mobileActiveIdx, setMobileActiveIdx] = useState(1); // Default to Pro plan
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={`${isMobile ? "" : "overflow-x-auto"} mb-[50px] px-[2%]`}>
      <div
        className={`flex ${
          isMobile
            ? "flex-col items-center gap-[40px]"
            : "flex-row items-start justify-center min-w-fit max-w-[1400px] mx-auto"
        } gap-0`}
      >
        {!isMobile && (
          <div className="sticky left-0 z-10 bg-white">
            <PlanCols />
          </div>
        )}
        <div
          className={`flex ${
            isMobile 
              ? "flex-col items-center gap-6" 
              : "flex-row items-start justify-center gap-0"
          }`}
        >
          {Plans.map((plan, idx) =>
            isMobile ? (
              <div
                key={idx}
                onClick={(e) => {
                  e.stopPropagation();
                  setMobileActiveIdx(idx);
                }}
              >
                <PlansMobile idx={idx} activeIdx={mobileActiveIdx} {...plan} />
              </div>
            ) : (
              <div
                key={idx}
                onMouseEnter={() => setMobileActiveIdx(idx)}
                onMouseLeave={() => setMobileActiveIdx(-1)}
              >
                <PlansWeb idx={idx} activeIdx={mobileActiveIdx} {...plan} />
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};

export default PricingComponent;
